export default {
    checkinSale: 'Check-In Sale',
    checkinEngineer: 'Check-In Engineer',
    yourLocation: 'Your location',
    jobId: 'Job ID',
    customerName: 'Customer Name',
    cancel: 'Cancel',
    submit: 'Submit',
    edit: 'Edit',
    save: 'Save',
    searching: 'Searching for your location ...',
    fieldRequired: 'This field is required',
    msgNoInquiry: 'You have no onsite inquiry today',
    networkError: 'Network error, please contact support for further information',
    msgSuccess: 'Save success',
    msgGPSError: 'Please turn on GPS. To indicate your location',
    getLocationError: 'Get location error',
    cannotGetLineId: 'Cannot get line user id'
}
